export default __webpack_public_path__ + "static/media/S-logo.ebd77b60.png";